import type { ComponentProps } from 'react';
import type React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';
import type { IconSize } from '@change-corgi/design-system-legacy/components/icon';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconInfo, iconInfoOutline } from '@change-corgi/design-system-legacy/icons';
import type { Box } from '@change-corgi/design-system-legacy/layout';

import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';

import { useInfoTooltip } from './hooks/useInfoTooltip';

export const InfoTooltip: React.FC<
	ComponentProps<typeof Box> & { isSunriseEnabled?: boolean; size?: IconSize | number }
> = ({ children, isSunriseEnabled, ref, size = 18, ...props }) => {
	const { translate } = useI18n();
	const { data, actions } = useInfoTooltip();
	const icon = data.isOpen ? iconInfo : iconInfoOutline;

	return (
		<Tooltip open={data.isOpen} onOpenChange={actions.setIsOpen} isSunriseEnabled={isSunriseEnabled}>
			<TooltipTrigger
				aria-label={translate('corgi.components.tooltips.info_tooltip.a11y.label')}
				aria-expanded={data.isOpen}
				onClick={actions.toggleTooltip}
				{...props}
			>
				<Icon icon={icon} color="currentColor" size={size} m={3} />
			</TooltipTrigger>
			<TooltipContent data-qa="tooltip-help-text" sx={{ zIndex: 5001 }}>
				{children}
			</TooltipContent>
		</Tooltip>
	);
};
